export enum TaskFilterDisplayLabel {
  All = 'All',
  Call = 'Call',
  LinkedInAutomation = 'LinkedIn Automation',
  Linkedin = 'Linkedin',
  Whatsapp = 'Whatsapp',
  ManualTasks = 'Custom Tasks',
}

export enum TaskFilterKey {
  All = 'all',
  Call = 'call',
  LinkedInAutomation = 'linkedInAutomation',
  Linkedin = 'linkedin',
  Whatsapp = 'whatsapp',
  ManualTasks = 'manualTasks',
}

export enum TaskStatusDisplayLabel {
  All = 'Status(All)',
  DueToday = 'Due Today',
  Upcoming = 'Upcoming',
  Overdue = 'Overdue',
  Completed = 'Completed',
  Skipped = 'Skipped',
}

export enum TaskStatusKey {
  All = 'all',
  DueToday = 'dueToday',
  Upcoming = 'upcoming',
  Overdue = 'overdue',
  Completed = 'completed',
  Skipped = 'skipped',
}
